var $196258ea25c96487$exports = {};
$196258ea25c96487$exports = {
    "close": `Lukk`,
    "notifications": `Varsler`
};


export {$196258ea25c96487$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
